<template>
  <section>
    <div class="row" v-if="enamad_payment">
      <div class="col-md-12 mt-2" v-if="error">
        <div class="alert alert-danger">{{ error }}</div>
      </div>

      <div v-if="!error" class="col-md-12 my-4">
        <div class="d-flex align-items-center justify-content-around">
          <div class="d-flex align-items-center">
            <div>{{ $t('enamad_services.enamad_pardakht') }}:</div>
            <div class="mx-2">
              {{ Number(enamad_amount).toLocaleString() + " ریال" }}
            </div>
          </div>
          <div>
            <button class="btn btn-success" @click="enamadPay" :disabled="btn_disable">{{ $t('enamad_services.enamad_pardakht') }}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="enamad_send_code">
      <div class="col-md-12 mt-2" v-if="error">
        <div class="alert alert-danger">{{ error }}</div>
      </div>

      <div class="col-md-12 my-4">
        <div class="d-flex align-items-center justify-content-around">
          <div class="d-flex align-items-center">
            <div>{{ $t('enamad_services.enamad_send_code') }}</div>
          </div>
          <div>
            <button disabled v-if="progress" class="btn btn-success">
               <div class="d-flex align-items-center justify-content-center">
                    <div class="mx-2">لطفا صبر کنید</div>
                    <div class="spinner-border spinner-border-sm text-white" role="status"></div>
               </div>
            </button>
            <button v-if="!progress" class="btn btn-success" @click="rePayment">{{ $t('enamad_services.enamad_send') }}</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="enamad_guide" class="p-3">
      <enamad-success :enamad_code="enamad_code"></enamad-success>
    </div>
  </section>
</template>

<script>
import { enamadServices , gatewayService} from '@/common/api.service'
import { BASE_PATH } from "@/common/config"
import enamadSuccess from '@/pages/enamad/paymentRedirect/enamadSuccess.vue'
import toastr from "toastr";
import {i18n} from "@/plugins/i18n";

export default {
  name: 'registerEnamad',
  data(){
    return {
      enamad_send_code: false,
      enamad_payment: false,
      enamad_guide: false,
      enamad_amount: 0,
      progress: false,
      enamad_code: '',
      error: null,
      btn_disable: false
    }
  },
  computed:{
    toastr() {
        toastr.options = {
          closeButton: true,
          positionClass: "toast-bottom-center",
          preventDuplicates: false,
          rtl: false
        }

        return toastr
      }
  },
  components:{
    enamadSuccess
  },
  methods: {
    rePayment(){
      this.progress = true
      enamadServices.getNamadCode(this.$route.params.hashid).then(() => {
        this.enamadPay()
      }).catch(({response}) => {
        this.toastr.error(response.data.message);
      }).finally(() => {
        this.progress = false
      })
    },
    enamadPay(){
            let userId = JSON.parse(localStorage.getItem('user'))
            const form = document.createElement("form")
            const input_shop_id = document.createElement("input")
            const input_user_id = document.createElement("input")
            form.action = BASE_PATH + '/gateway/enamad/pay'
            form.method = "GET"
            input_shop_id.type ="hidden"
            input_shop_id.name = "user_shop_id"
            input_shop_id.value = this.$route.params.hashid
            input_user_id.type ="hidden"
            input_user_id.name = "user_id"
            input_user_id.value = userId.id
            form.appendChild(input_user_id)
            form.appendChild(input_shop_id)
            document.body.appendChild(form)
            form.submit()
    }
  },
  mounted(){
    gatewayService.find(this.$route.params.hashid).then(response => {
      this.enamad_amount = response.data.data.namad_amount || 0
      if (response.data.data.namad_code === '-1'){
        this.error = i18n.t('enamad_services.enamad_user_error')
        this.btn_disable = true
        this.enamad_payment = true
      }
      if (response.data.data.namad_code === '-2'){
        this.error = i18n.t('enamad_services.enamad_user_error')
        this.btn_disable = true
        this.enamad_payment = true
      }
      if(!response.data.data.namad_payment_status && response.data.data.namad_code){
        this.enamad_payment = true
      }
      if(response.data.data.namad_code === null){
        this.error = i18n.t('enamad_services.namad_code_failed')
        this.enamad_send_code = true
      }
      if(response.data.data.namad_payment_status && response.data.data.namad_code !== null){
        this.enamad_code = response.data.data.namad_code
        this.enamad_guide = true
      }

    }).catch(({response}) => {
      throw new Error(response.data.message)
    })
}
};
</script>

<style scoped></style>
